import Vue from 'vue';
export default new Vue ({
    // data
    // methods
    // watch
})



// WEBPACK FOOTER //
// ./src/components/event-bus.js